import styled from 'styled-components';
import Box from '../Box';
export const BadgeElement = styled(Box) `
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
`;
